<template>
  <div class="container">
    <head-nav-bar title="预约挂号管理" :fixed="true" @click-left="back" />
    <div class="list mt-header-nav">
      <ContactCard v-model="contact" @change="onContactChange" />
      <div class="kong"></div>
      <van-tabs
        v-model="tabActive"
        @click="onClick"
        sticky
        :offset-top="46"
        style="width:100%;"
      >
        <van-tab title="预约挂号">
          <DataList
            api="Booking_List"
            :params="listParams1"
            :onAutoLoad="!lsOnLoat"
          >
            <template v-slot:item="item">
              <van-cell
                is-link
                @click="toInfo(item.obj, 0)"
                title-style="flex:3;"
              >
                <div slot="title">
                  <div>
                    {{ item.obj.departmentName }}
                    <span style="margin-left:0.5rem;"
                      >{{ item.obj.doctorName }} 医生</span
                    >
                  </div>
                  <div>
                    {{ item.obj.bookingStatusDesc }}（{{
                      item.obj.payStatusDesc
                    }}）
                  </div>
                  <div>
                    就诊日期：{{ item.obj.bookingDate }}
                    {{ item.obj.startBookingTime }} ~
                    {{ item.obj.endBookingTime }}
                  </div>
                  <div class="text-less" style="font-size:0.35rem;">
                    挂号日期：{{ item.obj.creationTime }}
                  </div>
                </div>
                <div class="value">
                  {{ item.obj.amount }}
                </div>

                <van-icon
                  slot="right-icon"
                  name="arrow"
                  style="line-height: 2.3rem;"
                />
              </van-cell>
            </template>
          </DataList>
        </van-tab>
        <van-tab title="历史挂号">
          <DataList
            api="Booking_List"
            :params="listParams2"
            :onAutoLoad="lsOnLoat"
          >
            <template v-slot:item="item">
              <van-cell
                is-link
                @click="toInfo(item.obj, 1)"
                title-style="flex:3;"
              >
                <div slot="title">
                  <div>
                    {{ item.obj.departmentName }}
                    <span style="margin-left:0.5rem;"
                      >{{ item.obj.doctorName }} 医生</span
                    >
                  </div>
                  <div>
                    {{ item.obj.bookingStatusDesc }}（{{
                      item.obj.payStatusDesc
                    }}）
                  </div>
                  <div>
                    就诊日期：{{ item.obj.bookingDate }}
                    {{ item.obj.startBookingTime }} ~
                    {{ item.obj.endBookingTime }}
                  </div>
                  <div class="text-less" style="font-size:0.35rem;">
                    挂号日期：{{ item.obj.creationTime }}
                  </div>
                </div>
                <div class="value">
                  {{ item.obj.amount }}
                </div>

                <van-icon
                  slot="right-icon"
                  name="arrow"
                  style="line-height: 2.3rem;"
                />
              </van-cell>
            </template>
          </DataList>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import { List, Tag, Button, Icon, Cell, Tab, Tabs } from "vant";
import DataList from "@/components/DataList";
import ContactCard from "@/components/ContactCard";

export default {
  name: "userOrderList",
  components: {
    DataList,
    ContactCard,
    [List.name]: List,
    [Tag.name]: Tag,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
  },
  data() {
    return {
      contact: {},
      list: [],
      loading: false,
      finished: false,
      tabActive: 0,
      listParams1: { IsHistoryRecord: false },
      listParams2: { IsHistoryRecord: true },
      lsOnLoat: false,
    };
  },
  watch: {
    contact(contact) {
      this.listParams1 = {
        DiagnosisCardNo: contact.diagnosisCardNo,
        IsHistoryRecord: false,
      };
      this.listParams2 = {
        DiagnosisCardNo: contact.diagnosisCardNo,
        IsHistoryRecord: true,
      };
    },
  },
  created() {
    const query = this.$route.query;
    if (query && query.tab == 1) {
      this.tabActive = 1;
      this.lsOnLoat = true;
    }
  },
  methods: {
    onClick(name) {
      if (name == 0) {
        this.listParams1 = {
          DiagnosisCardNo: this.contact.diagnosisCardNo,
          IsHistoryRecord: false,
          PageIndex: 0,
        };
      } else {
        this.listParams2 = {
          DiagnosisCardNo: this.contact.diagnosisCardNo,
          IsHistoryRecord: true,
          PageIndex: 0,
        };
      }
    },
    toInfo(item, type) {
      this.$router.push({
        name: "userOrderInfo",
        query: {
          Id: item.id,
          type: type,
        },
      });
    },
    //切换就诊人
    onContactChange() {
      console.log(this.contact);
      this.listParams1 = {
        DiagnosisCardId: this.contact.diagnosisCardNo,
        IsHistoryRecord: false,
      };
      this.listParams2 = {
        DiagnosisCardId: this.contact.diagnosisCardNo,
        IsHistoryRecord: true,
      };
    },
    back() {
      this.$router.push({
        name: "userIndex",
      });
    },
  },
};
</script>

<style lang="less" scoped>
.list-item {
  .value {
    line-height: 2.3rem;
    color: #333;
    font-size: 0.5rem;
  }
  .van-cell__title {
    flex: 2;
  }
}
</style>
